"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Forward = void 0;
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const forwardError_1 = require("./model/error/forwardError");
class Forward {
    constructor(instance) {
        this.instance = instance;
    }
    getForwardURL(forward) {
        return new Promise((resolve, reject) => {
            const URL = `/forward/m?forwarded_url=${forward}`;
            this.instance.get(URL)
                .then((res) => {
                const forwardInfo = res.data;
                resolve(forwardInfo);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'getForwardURL'));
            });
        });
    }
    handleError_(error, log) {
        if (error.response.data.error !== undefined) {
            return new forwardError_1.ForwardError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.error);
        }
        else {
            return new forwardError_1.ForwardError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Forward = Forward;
//# sourceMappingURL=forward.js.map